import { getRaidAbi } from "./raidAbi"
import { getTokenAbi } from "./tokenAbi"
import { ethers } from "ethers"

export const provider = new ethers.providers.JsonRpcProvider('https://bsc-dataseed.binance.org/')
const raidAbi = getRaidAbi() 
const tokenAbi = getTokenAbi()

const address = '0xcfA857d6EC2F59b050D7296FbcA8a91D061451f3'
const btcAddress = '0xF45cd219aEF8618A92BAa7aD848364a158a24F33'

export const setupContract = async (pool: string) => { 
    const contract = new ethers.Contract(pool, tokenAbi, provider)
    return contract
}

export const btcContract = new ethers.Contract(btcAddress, tokenAbi, provider)
export const raidContract = new ethers.Contract(address, raidAbi, provider)